import { Component, OnInit } from '@angular/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { MessageService } from 'primeng/api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from './consola/app.config';
import { CONSTANTES, CONSTANTES_SESION } from './core/_util/services-util';
import { AlertasService } from './core/_services/alerta.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

    protected baseUrl: string = AppConfig.settings.apiServer.ruta;
    public loginData = { username: '', password: '' };
    idleState = 'No iniciado.';
    timedOut = false;
    lastPing?: Date = null;
    contador = 10;
    displayPanel = false;

    constructor(
        private http: HttpClient,
        private idle: Idle,
        public keepalive: Keepalive,
        public messageService: MessageService,
        public msj: AlertasService,
        private router: Router) {

        // Establece un tiempo de espera inactivo de 5 segundos, con fines de prueba
        idle.setIdle(600);
        // Establece un período de tiempo de espera de 5 segundos. después de 10 segundos de inactividad, el usuario se considerará agotado.
        idle.setTimeout(this.contador);
        // Establece las interrupciones predeterminadas, en este caso, cosas como clics, desplazamientos, toques en el documento
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        idle.onIdleEnd.subscribe(() => {
            if (sessionStorage.getItem(CONSTANTES_SESION.TOKEN) !== null && sessionStorage.getItem(CONSTANTES_SESION.TOKEN) !== undefined) {
                this.idleState = 'Cuenta Reiniciada.';
                this.reset();
            }
        });

        idle.onTimeout.subscribe(() => {
            if (sessionStorage.getItem(CONSTANTES_SESION.TOKEN) !== null && sessionStorage.getItem(CONSTANTES_SESION.TOKEN) !== undefined) {
                this.idleState = 'Desconectado!';
                this.timedOut = true;

                sessionStorage.clear();
                this.router.navigate(['/login']);
                this.msj.cierreSesion('Su sesión ha concluido por inactividad.');
            }
        });

        idle.onIdleStart.subscribe(() => {
            this.idleState = 'Cuenta Iniciada!';
        });

        idle.onTimeoutWarning.subscribe((countdown) => {
            if (sessionStorage.getItem(CONSTANTES_SESION.TOKEN) !== null && sessionStorage.getItem(CONSTANTES_SESION.TOKEN) !== undefined) {
                if (countdown === this.contador) {
                    this.messageService.add({
                        severity: 'warn', summary: 'Advertencia', key: 'tc', sticky: false, life: 1000 * countdown,
                        detail: 'Será desconectado en ' + countdown + ' segundos.'
                    });
                }
            }
        });

        // sets the ping interval to 15 seconds
        keepalive.interval(30);

        keepalive.onPing.subscribe(() => this.lastPing = new Date());

        this.reset();

    }

    ngOnInit() {
    }

    login() {
        let usuario = sessionStorage.getItem('username');
        if (this.loginData.username === undefined || this.loginData.username === null || this.loginData.username === '') {
            this.msj.info('Usuario obligatorio.');
        } else if (this.loginData.password === undefined || this.loginData.password === null || this.loginData.password === '') {
            this.msj.info('contraseña obligatoria.');
        } else if (usuario !== this.loginData.username) {
            this.msj.info('El usuario no es el mismo autenticado.');
        } else {
            let login = {
                cedula: this.loginData.username,
                password: this.loginData.password
            }
            const headers = new HttpHeaders({
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            });
            this.http.post(this.baseUrl + CONSTANTES.URI_LOGIN, login, { headers: headers })
                .subscribe(
                    (data: any) => {
                        if (data !== null && data.token !== undefined && data.token !== null) {
                            sessionStorage.setItem(CONSTANTES_SESION.TOKEN, 'CRM:' + data.token);
                            this.idle.watch();
                            this.reset();
                        }
                    },
                    (err: any) => {
                        this.msj.error('Contraseña y/o usuario incorrecto.');
                    }
                );
        }
    }

    enter(event) {
        if (event.key === 'Enter') {
            this.login();
        }
    }

    reset() {
        this.idle.watch();
        // this.idleState = 'Started.';
        this.timedOut = false;
    }

    /*
    @HostListener('window:keydown', ['$event'])
    handleKeyDown(event: KeyboardEvent) {
        if (event.keyCode == 44 || event.keyCode == 123 || (event.ctrlKey && event.shiftKey && event.which === 74)) {
            event.preventDefault()
        }
    }*/

}
